import React, { useState, useEffect } from "react";
import BiztranControls from "../../biztran_controls/BiztranControls";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import { Grid, Tooltip } from "@material-ui/core";
import Moment from "moment";
import CreateSalesTargetvsActual from "./CreateSalesTargetvsActual";

let Year = new Date().getFullYear()

const SalesTargetvsActual = () => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [SalesTargetID, setSalesTargetID] = useState('');
  const [response, fetchData] = UseFetchData();
  const [FinancialYearID, setFinancialYearID] = useState('');
  const [Month, setMonth] = useState('');
  const [SalesExecutiveID, setSalesExecutiveID] = useState('');
  const [Count, setCount] = useState();
  // const [defaultFinancialYearID, setdefaultFinancialYearID] = useState();
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [ComboFinYear, setComboFinYear] = useState([]);
  const [ComboSalesExecutive, setComboSalesExecutive] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [Mode, setMode] = useState('');


  const PopulateData = () => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("AccYearID", FinancialYearID);
    bodyFormData.append("Month", Month);
    bodyFormData.append("SalesExecutiveID", SalesExecutiveID);
    bodyFormData.append('SearchString', FinancialYearID);
    fetchData("SalesTargetvsActual/List", bodyFormData);
  }

  const MonthOption = [
    { id: "January", title: "January" },
    { id: "February", title: "February" },
    { id: "March", title: "March" },
    { id: "April", title: "April" },
    { id: "May", title: "May" },
    { id: "June", title: "June" },
    { id: "July", title: "July" },
    { id: "August", title: "August" },
    { id: "September", title: "September" },
    { id: "October", title: "October" },
    { id: "November", title: "November" },
    { id: "December", title: "December" },
  ];

  const handleOpenModal = () => {
    setOpen(true);
    setSalesTargetID('');
    setMode('Insert');
  }

  // const onFinancialYearClear = (e) => {
  //  // debugger;
  //   setFinancialYearID(e.target.value);
  //   // setdefaultFinancialYearID();
  // }

  const GetComboData = () => {
    var bodyFormData = new FormData();
    fetchComboData("SalesTargetvsActual/ComboData", bodyFormData);
  };

  const openModal = (row) => {
    setSalesTargetID(row.id);
    setOpen(true);
    setMode('Update');
  }

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Edit</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },
      {
        field: "SalesExecutive",
        headerName: "Sales Executive",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
      },
      {
        field: "MonthYear",
        headerName: "Month/Year",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
        valueFormatter: params =>
          Moment(params?.value).format("DD/MM/YYYY"),
      },
      {
        field: "TargetInLakhs",
        headerName: "Target (Lakhs)",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
      },
      {
        field: "AmtInLaks",
        headerName: "Actual (Lakhs)",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
      },
      {
        field: "CreatedBy",
        headerName: "Created By",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "CreatedOn",
        headerName: "Created On",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
        valueFormatter: params =>
          Moment(params?.value).format("DD/MM/YYYY"),
      },
    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);
  }, [response]
  );

  useEffect(() => {
    // debugger;
    PopulateData();
    GetComboData();
  }, [])

  useEffect(() => {
    // debugger;
    if (ComboDataResponse !== undefined) {
      if (ComboDataResponse["FinancialYear"] !== undefined && ComboDataResponse["SalesExecutive"] !== undefined) {
        console.log(ComboDataResponse["FinancialYear"]);
        setComboFinYear(ComboDataResponse["FinancialYear"]);
        setComboSalesExecutive(ComboDataResponse["SalesExecutive"]);
        var currentYear = new Date().getFullYear();
        var FinYear = currentYear.toString()
        for (let i = 0; i < ComboDataResponse["FinancialYear"].length; i++) {
          var Year = ComboDataResponse["FinancialYear"][i].title.split('-');
          if (Year[0] === FinYear) {
            setFinancialYearID(ComboDataResponse["FinancialYear"][i].id);
          }
        }
      }
    }
  }, [ComboDataResponse]);



  //for exporting in csv file
  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ marginLeft: '93%' }}>
        <GridToolbarExport csvOptions={{
          fields: ['SalesExecutive', 'MonthYear', 'TargetInLakhs', 'CreatedBy', 'CreatedOn']
        }} />
      </GridToolbarContainer>
    );
  }

  // function CustomToolbar() {
  //   return (
  //     <GridToolbarContainer className={gridClasses.toolbarContainer}>
  //       <GridToolbarExport csvOptions={{
  //          fields: ['SalesExecutive', 'MonthYear', 'TargetInLakhs', 'CreatedBy', 'CreatedOn']
  //       }} />
  //     </GridToolbarContainer>
  //   );
  // }


  return (
    <div >
      <Grid container direction="row" style={{ marginTop: 10 }}>
        <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
          <BiztranControls.Select
            label="Financial Year"
            id="FinancialYear"
            options={ComboFinYear}
            // value={FinancialYearID}
            // defaultValue={defaultFinancialYearID}
            // onChange={(e) => onFinancialYearClear()}
            onChange={(e) => setFinancialYearID(e.target.value)}

          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2} xl={2} >
          <BiztranControls.Select
            label="Month"
            id="Month"
            options={MonthOption}
            onChange={(e) => setMonth(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2} xl={2} >
          <BiztranControls.Select
            label="Sales Executive"
            id="SalesExecutive"
            options={ComboSalesExecutive}
            onChange={(e) => setSalesExecutiveID(e.target.value)}
          />
        </Grid>
        <Grid container xs={12} sm={12} md={6} lg={4} xl={2} direction="row" >
          <Grid item>
            <BiztranControls.Button
              text="SEARCH"
              startIcon={<SearchIcon />}
              onClick={() => {
                PopulateData();
              }}
            />
          </Grid>
          <Grid item style={{ marginTop: 10 }}>
            <label style={{ fontWeight: 'bold' }}>{Count}</label>
          </Grid>
          <Grid item>
            <BiztranControls.Button
              text="ADD NEW"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => {
                handleOpenModal();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <BiztranControls.DataGrid
        rowHeight={25}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        Height="520px"
        Width="100%"
        components={{ Toolbar: CustomToolbar, }}
      />
      <ModalFrame
        title="Sales Target"
        maxWidth="sm"
        isOpen={isOpen}
        headerAlign="center"
        setOpen={setOpen}
        setMode={setMode}
      >
        <CreateSalesTargetvsActual
          SalesTargetID={SalesTargetID}
          SalesExecutiveID={SalesExecutiveID}
          setOpen={setOpen}
          Mode={Mode}
          PopulateData={PopulateData}
        />
      </ModalFrame>
    </div>
  );
};

export default SalesTargetvsActual;